import type { Ref } from 'vue'
import throttle from '@/lib/throttle'

interface UseInfiniteScroll {
  LoadMoreRef: Ref<HTMLElement | null>
}

export function useInfiniteScroll(callback: IntersectionObserverCallback): UseInfiniteScroll {
  const LoadMoreRef = ref<HTMLElement | null>(null)
  let intersectionObserver: IntersectionObserver | null = null

  watch(
    LoadMoreRef,
    loadMoreRef => {
      if (!process.client) return

      intersectionObserver = new IntersectionObserver(throttle(callback, 500))
      if (loadMoreRef) intersectionObserver?.observe(loadMoreRef)
    },
    { immediate: true }
  )

  onUnmounted(() => {
    intersectionObserver?.disconnect()
  })

  return { LoadMoreRef }
}
